/** @jsxImportSource theme-ui */
import styled from '@emotion/styled'
import mainLogo from 'assets/svg/pergamin-logo.svg'

const MainLogo = styled.div`
  background: url(${mainLogo});
  width: 416px;
  height: 146px;
  background-size: contain;
`

export default MainLogo
